var SmoothScrollFactory = function ($element) {
  var _element = $element;
  var _options = {
    speed: 500,
    animate: 'swing',
    position: 0,
  };

  var _setOptions = function (options) {
    options = options || {};
    Object.assign(_options, options);
    return this;
  };

  var _action = function () {
    $('html, body').animate(
      { scrollTop: _options.position },
      _options.speed,
      _options.animate
    );
  };

  var _setOnClick = function () {
    _element.on('click', _action);
  };

  var _reset = function (options) {
    _element.off('click');
    _setOptions(options);
    _setOnClick();
  };

  return {
    setOption: _setOptions,
    setOnClick: _setOnClick,
    reset: _reset,
  };
};
